import React from 'react';
import { RouteEnum } from './routeEnum';
import { paths } from './paths';
import { AppRoute, RoutesByRole } from './routes.types';
import { IconDashboard, IconUsers, IconOrders } from '../components/Icons';

export { APP_ROLES, defaultRoutesByRole } from './paths';
export type { AppRole } from './paths';

const Dashboard = React.lazy(() => import('../../domains/dashboard'));
const Users = React.lazy(() => import('../../main/users'));
const Orders = React.lazy(() => import('../../main/orders'));
const Mentors = React.lazy(() => import('../../domains/mentor'));
const Settings = React.lazy(() => import('../../domains/settings'));

const SignIn = React.lazy(
  () => import('../../domains/auth/ui/pages/SignInPage'),
);
const SignUp = React.lazy(
  () => import('../../domains/auth/ui/pages/SignUpPage'),
);
const ForgotPassword = React.lazy(
  () => import('../../domains/auth/ui/pages/ForgotPasswordPage'),
);

export const routesByRole: RoutesByRole = {
  mentor: [
    // -------------------------------------------- mentor
    {
      element: Dashboard,
      route: `/mentor${paths.dashboard}`,
      pageTitle: 'navigation.dashboard',
      isActive: currentPath => currentPath.includes('/dashboard'),
      renderIcon: currentPath => (
        <IconDashboard isActive={currentPath.includes('/dashboard')} />
      ),
    },
    {
      element: Users,
      route: `/mentor${paths.users}`,
      pageTitle: 'navigation.users',
      isActive: currentPath => currentPath.includes('/users'),
      renderIcon: currentPath => (
        <IconUsers isActive={currentPath.includes('/users')} />
      ),
    },
    {
      element: Orders,
      route: `/mentor${paths.orders}`,
      pageTitle: 'navigation.orders',
      isActive: currentPath => currentPath.includes('/orders'),
      renderIcon: currentPath => (
        <IconOrders isActive={currentPath.includes('/orders')} />
      ),
    },
    {
      element: Settings,
      route: `/mentor${paths.settings}`,
    },
    {
      element: Settings,
      route: `/mentor${paths.settingsProfile}`,
    },
  ],
  student: [
    // -------------------------------------------- student
    {
      element: Dashboard,
      route: `/student${paths.dashboard}`,
      pageTitle: 'navigation.dashboard',
      isActive: currentPath => currentPath.includes('/dashboard'),
      renderIcon: currentPath => (
        <IconDashboard isActive={currentPath.includes('/dashboard')} />
      ),
    },
    {
      element: Mentors,
      route: `/student${paths.mentors}`,
      pageTitle: 'navigation.mentors',
      isActive: currentPath => currentPath.includes('/mentors'),
      renderIcon: currentPath => (
        <IconUsers isActive={currentPath.includes('/mentors')} />
      ),
    },
    {
      element: Orders,
      route: `/student${paths.orders}`,
      pageTitle: 'navigation.orders',
      isActive: currentPath => currentPath.includes('/orders'),
      renderIcon: currentPath => (
        <IconOrders isActive={currentPath.includes('/orders')} />
      ),
    },
    {
      element: Settings,
      route: `/student${paths.settings}`,
    },
    {
      element: Settings,
      route: `/student${paths.settingsProfile}`,
    },
  ],
};

export const publicRoutes: AppRoute[] = [
  {
    element: SignIn,
    route: RouteEnum.SIGN_IN,
    requireAuth: false,
  },
  {
    element: SignUp,
    route: RouteEnum.SIGN_UP,
    requireAuth: false,
  },
  {
    element: ForgotPassword,
    route: RouteEnum.FORGOT_PASSWORD,
    requireAuth: false,
  },
];
